import React, { useEffect } from 'react';
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { forwardRef, useRef, useImperativeHandle } from "react"

const DeleteDialogModal = (props: DeleteDialogProps) => {
  const {
    title,
    message,
    activeType,
    onClose,
    handleDelete,
    handleReactive,
    ...rest
  } = props;


  return (
    <Dialog
      className='xs-modal '
      onClose={() => {
        if (onClose != null) {
          onClose();
        }
        
      }} title={activeType === true ? `Reactivate ${title}` : `Delete ${title}`}>
      <p
        style={{
          margin: "25px",
        }}
      >
        {activeType === true ? `Are you sure you want to reactivate ${message}?` : ` Are you sure you want to delete ${message}?`}
      </p>
      <DialogActionsBar>
        {activeType ? (
          <button
            className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base blue-primary"
            onClick={handleReactive}
          >
            Yes
          </button>
        ) : (
          <button
            className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base textWhite blue-primary"
            onClick={handleDelete}
          >
            Yes
          </button>
        )}
        <button
          className=" k-button-md k-rounded-md k-button-solid k-button-solid-base grey-secondary sealBtn "
          onClick={() => {
            if (onClose != null) {
              onClose();
            }
         
          }}
        >
          No
        </button>

      </DialogActionsBar>
    </Dialog>
  )
}

export default DeleteDialogModal

export interface DeleteDialogProps {
  title: string
  message: String
  activeType?: boolean
  onClose?: () => void | number;
  handleDelete?: () => void;
  handleReactive?: () => void;
}